import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-bold text-background-50" style={{ fontFamily: "var(--font-heading)" }}>
                  红桃视频
                </span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed">
                红桃视频网页版为您提供海量高清视频在线免费观看体验。无需下载安装，打开浏览器即可畅享。
              </p>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold mb-4 text-sm">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">首页</Link>
                <Link to="/category/movie" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">电影</Link>
                <Link to="/category/tv" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">电视剧</Link>
                <Link to="/category/anime" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">动漫</Link>
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold mb-4 text-sm">关于我们</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/about" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">品牌介绍</Link>
                <a href="#" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">隐私政策</a>
                <a href="#" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">服务条款</a>
                <a href="#" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap" rel="nofollow">帮助中心</a>
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold mb-4 text-sm">关注我们</h4>
              <div className="flex gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-50 transition-colors" rel="nofollow">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-50 transition-colors" rel="nofollow">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-50 transition-colors" rel="nofollow">
                  <i className="ri-bilibili-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-50 transition-colors" rel="nofollow">
                  <i className="ri-live-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-foreground-500 text-xs">
              &copy; {currentYear} 红桃视频网页版 版权所有 | 京ICP备XXXXXXXX号
            </p>
            <p className="text-foreground-600 text-xs">
              本站内容仅供学习交流，请勿用于商业用途
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}